import React from "react";
import { Menu, Dropdown } from "antd";
import { Link } from "react-router-dom";
import { DownOutlined } from "@ant-design/icons";
import "../header/header.style.css";
const MobileSidebar = (props) => {
  const { location } = props;
  const onClick = ({ key }) => { };
  const menu = (
    <Menu onClick={onClick}>
      <a className="nav-mobile-item nav-link" href="/medical-services">
        <Menu.Item className="cursor_pointer">
          Home Medical Services
        </Menu.Item>
      </a>
      <a className="nav-mobile-item nav-link" href="/telecommunication-services">
        <Menu.Item className="cursor_pointer">
          Telecommunication Services
        </Menu.Item>
      </a>
    </Menu>
  );
  const { openSidebar, setOpenSidebar } = props;
  const closeSidebarMenu = () => {
    setOpenSidebar(false);
    let close = document.getElementById("modalOpen");
    close.classList.remove("mobileNavOpen");
  };
  return (
    <div
      className="nav-mobile-mod is-visible"
      style={{ display: openSidebar ? "block" : "none" }}
    >
      <div className="nav-mobile-hdr">
        <a
          style={{ cursor: "pointer" }}
          className="js-closeMobileNav nav-mobile-close"
          onClick={closeSidebarMenu}
        >
          Close
        </a>
      </div>
      <ul className="nav-mobile-list">
        <li className="nav-mobile-item">
          <a href="/" className="nav-mobile-link">
            Home
          </a>
        </li>
        <li className="nav-mobile-item">
          <a href="/howitworks" className="nav-mobile-link">
            How it works
          </a>
        </li>
        <li className="nav-mobile-item">
          <Dropdown overlay={menu}>
            <a
              className="ant-dropdown-link nav-mobile-link"
              onClick={(e) => e.preventDefault()}
            >
              Home Services <DownOutlined />
            </a>
          </Dropdown>
        </li>
        <li className="nav-mobile-item">
          <a href="/blog" className="nav-mobile-link">
            Blogs
          </a>
        </li>
        <li className="nav-mobile-item">
          <a href="/contact" className="nav-mobile-link">
            Contact Us
          </a>
        </li>
        <li className="nav-mobile-item">
          <a href="/contact/FAQS" className="nav-mobile-link">
            FAQs
          </a>
        </li>
        <li className="nav-mobile-item">
          <a href="/offers" className="nav-mobile-link">
            Offers
          </a>
        </li>
        <li className="nav-mobile-item">
          <a href="/offering" className="nav-mobile-link">
            Outsourcing Services
          </a>
        </li>
      </ul>
      <div className="nav-mobileFtr">
        <a target="blank" href="https://apps.apple.com/pk/app/dawa-asaan/id1528679507" className="left nav-mobileFtr-mod">
          <img
            style={{ width: "100%" }}
            src={require("../../assets/images/ios.png")}
          ></img>
        </a>
        <a target="blank" href="https://play.google.com/store/apps/details?id=com.novatorsols.dawaasaan" className="nav-mobileFtr-mod right">
          <img
            style={{ width: "100%" }}
            src={require("../../assets/images/google.png")}
          ></img>
        </a>
      </div>
    </div>
  );
};
export default MobileSidebar;
